import React, {useState, useContext} from 'react';
import { getDocuments, postDocuments } from '../api/kyc';
import {AuthContext} from '../context/AuthContext';
import {postRefreshToken} from '../api/refreshToken'
import jwt_decode from "jwt-decode";

export const useKyc = () => {
    const { setLoading ,checkToken, setRefreshToken } = useContext(AuthContext);
    const [document, setDocument] = useState([]);

    const postDocument = async({typeOfDocumentId, files})=>{
        checkToken()
        try {
            setLoading(true);
            const {data} =  await postDocuments({typeOfDocumentId, files});
            //console.log(data);
            setLoading(false);
            return true

        } catch (e) {
            setLoading(false);
            //console.log(e.request);
            return false
        }
    }

    const getDocument = async()=> {
        checkToken()
        try {
            setLoading(true);
            const {data} = await getDocuments();
            //console.log(data.data)
            setDocument(data.data);
            setLoading(false);
            return true
        } catch (e) {
            setLoading(false);
            //console.log(e.request);
            return false
        }
    } 

    const refreshToken = async () => {
        let token = await localStorage.getItem('token');
        let tokenDecode = jwt_decode(token);
        let refreshToken = await localStorage.getItem('refreshToken');
  
        //console.log({token, refreshToken})
      
        let refresh = await postRefreshToken(
            token,
            refreshToken
        ).then((data)=>{
           // //console.log(data);
           setRefreshToken({
             token: token,
             tokenDecoded: tokenDecode,
             refreshToken: refreshToken
           })
  
           //console.log(tokenDecode)
           
           localStorage.setItem('token', data.data.data.accessToken);
           localStorage.setItem('refreshToken', data.data.data.refreshToken);
           ////console.log('token actualizado');
      
        }).catch((e)=>{
            ////console.log(e.request);
        })
      }

    return{
        postDocument,
        refreshToken,
        getDocument,
        document
    }
}